/**
 * Keyboard actions as data, mirroring GamepadMap: defaults, a tolerant
 * loader over settings JSON, and display labels. Mouse fire and Escape
 * are deliberately not here; they are fixed vocabulary.
 */

export const KEY_ACTIONS = [
  { id: 'forward', name: 'FORWARD' },
  { id: 'back', name: 'BACK' },
  { id: 'left', name: 'LEFT' },
  { id: 'right', name: 'RIGHT' },
  { id: 'jump', name: 'JUMP' },
  { id: 'sprint', name: 'SPRINT' },
  { id: 'fireA', name: 'PORTAL A (ALT)' },
  { id: 'fireB', name: 'PORTAL B (ALT)' },
  { id: 'respawn', name: 'RESPAWN' },
  { id: 'clear', name: 'CLEAR PORTALS' },
];

export const DEFAULT_KEYS = {
  forward: 'KeyW',
  back: 'KeyS',
  left: 'KeyA',
  right: 'KeyD',
  jump: 'Space',
  sprint: 'ShiftLeft',
  fireA: 'KeyE',
  fireB: 'KeyF',
  respawn: 'KeyR',
  clear: 'KeyQ',
};

/** Stored binds overlay the defaults; garbage in settings is survivable. */
export function loadKeyBinds(settings) {
  const out = { ...DEFAULT_KEYS };
  try {
    const stored = JSON.parse(settings.get('keyBinds') || '{}');
    for (const [action, code] of Object.entries(stored)) {
      if (action in out && typeof code === 'string' && code) out[action] = code;
    }
  } catch { /* defaults stand */ }
  return out;
}

/** 'KeyW' -> 'W', 'ShiftLeft' -> 'L-SHIFT', 'ArrowUp' -> 'UP', ... */
export function keyLabel(code) {
  if (!code) return '---';
  if (code.startsWith('Key')) return code.slice(3);
  if (code.startsWith('Digit')) return code.slice(5);
  if (code.startsWith('Arrow')) return code.slice(5).toUpperCase();
  const special = {
    Space: 'SPACE',
    ShiftLeft: 'L-SHIFT', ShiftRight: 'R-SHIFT',
    ControlLeft: 'L-CTRL', ControlRight: 'R-CTRL',
    AltLeft: 'L-ALT', AltRight: 'R-ALT',
    Tab: 'TAB', Backquote: '`', Minus: '-', Equal: '=',
    BracketLeft: '[', BracketRight: ']', Semicolon: ';', Quote: "'",
    Comma: ',', Period: '.', Slash: '/', Backslash: '\\',
    Enter: 'ENTER', CapsLock: 'CAPS',
  };
  return special[code] ?? code.toUpperCase();
}
